import { Fragment } from 'react';
import { css } from '@emotion/react';
import { t } from 'i18next';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, PopoverDialog, usePopoverDialog } from '@frontend/design-system';
import { ForYouFilterType } from '../constants';

type PopoverFilterProps = {
  filter: ForYouFilterType;
};

export const PopoverFilter = ({ filter }: PopoverFilterProps) => {
  const { getTriggerProps, getDialogProps, close, isOpen } = usePopoverDialog<HTMLButtonElement>({
    placement: 'bottom-start',
  });

  return (
    <Fragment key={filter.id}>
      <Button
        {...getTriggerProps()}
        variant='secondary'
        css={{
          fontSize: theme.spacing(1.5),
          padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
          background: theme.colors.neutral10,
          border: 'none',
          height: 24,
          display: filter.hide ? 'none' : 'block',
        }}
        trackingId={`${filter.id}-for-you-nc-button`}
      >
        <Icon name={filter.iconName} />
        {t(`${filter.displayName}`)}
        <Icon name={`caret-${isOpen ? 'up' : 'down'}-tiny`} />
      </Button>

      <PopoverDialog
        css={css`
          border-radius: ${theme.borderRadius.medium};
          box-shadow: 0px 4px 24px 0px #0000001a;
          border: 1px solid ${theme.colors.neutral20};
          padding: 0;
        `}
        {...getDialogProps()}
      >
        <filter.component closePopOver={close} />
      </PopoverDialog>
    </Fragment>
  );
};
